import { ALL_POSTS,ADD_POST,EDIT_POST,DELETE_POST,TOST_MESSAGE, ALL_MY_DIARY, POST_DETAILS, DIARY_DETAILS, ALL_FEEDS, ADD_REPOST } from '../actions/actionTypes';

const initialState = {
  cardItemDataShow:false,opentost:false,tost_msg:'',addPostSuccess:false,myDiaryData:[],editPostSuccess:false,myPostData:[],postDetailsData:[],diaryDetailsData:[],allPostData:[],addRePostSuccess:false
};


export default function posts(state = initialState, action) {

  switch (action.type) {
      case ALL_POSTS:
      return{
       ...state,
       myPostData:action.myPostData
      };
      case POST_DETAILS:
      return{
       ...state,
       postDetailsData:action.postDetailsData
      };
      case ALL_MY_DIARY:
      return{
       ...state,
       myDiaryData:action.myDiaryData
      };
      case DIARY_DETAILS:
      return{
       ...state,
       diaryDetailsData:action.diaryDetailsData
      };
      case ADD_POST:
      return{
       ...state,
       addPostSuccess:action.success,
      };
      case ADD_REPOST:
      return{
       ...state,
       addRePostSuccess:action.success,
      };
      case EDIT_POST:
      return{
       ...state,
       editPostSuccess:action.success,
      };
      case DELETE_POST:
      return{
       ...state,
      };
      case ALL_FEEDS:
      return{
       ...state,
       allPostData:action.allPostData
      };
      case TOST_MESSAGE:
        return{
          ...state,
          openTost:action.openTost,
          Tost_msg:action.Tost_msg,
          Msg_type:action.Msg_type,
        };
    default: return state;
  }
};